import { render } from "./ReviewsQASection.vue?vue&type=template&id=0fb64eec&scoped=true"
import script from "./ReviewsQASection.vue?vue&type=script&lang=js"
export * from "./ReviewsQASection.vue?vue&type=script&lang=js"

import "./ReviewsQASection.vue?vue&type=style&index=0&id=0fb64eec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb64eec"]])

export default __exports__